import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f2f78766"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查看")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { title: "简历刷新日志" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_input, {
        placeholder: "关键字",
        value: _ctx.searches.keywords,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.keywords) = $event)),
        style: {"width":"200px"}
      }, null, 8, ["value"]),
      _createVNode(_component_a_button, {
        style: {"margin-left":"10px"},
        type: "primary",
        onClick: _ctx.onSearch
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        style: {"margin-left":"10px"},
        onClick: _ctx.onReset
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_table, {
        dataSource: _ctx.list,
        columns: _ctx.columns,
        loading: _ctx.loading,
        bordered: "",
        pagination: _ctx.pagination,
        onChange: _ctx.handleTableChange,
        style: {"margin-top":"10px"}
      }, {
        bodyCell: _withCtx(({ column, text, record }) => [
          (column.key === 'resume_advantage')
            ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(record.resume_advantage), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_button, { type: "link" }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (column.key === 'name')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(record.user.nickname), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'avatar')
            ? (_openBlock(), _createBlock(_component_a_image, {
                key: 2,
                src: record.user.avatar,
                style: {"width":"50px"}
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          (column.key === 'expectWorks')
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(record.expectWorks, (item, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: index,
                  style: {"margin-right":"20px"}
                }, _toDisplayString(item.position_name), 1))
              }), 128))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"])
    ]),
    _: 1
  }))
}